import { startIO } from '../io-tools.js';
export const IORecordMixin = {
    save(options = {}) {
        const endpoint = this.getEndpoint(), json = this.toJSON(Object.assign({ ioMethod: 'save' }, options));
        return startIO(this, this.isNew() ?
            endpoint.create(json, options, this) :
            endpoint.update(this.id, json, options, this), options, update => {
            this.set(update, Object.assign({ parse: true, ioMethod: 'save' }, options));
        });
    },
    fetch(options = {}) {
        return startIO(this, this.getEndpoint().read(this.id, options, this), options, json => this.set(json, Object.assign({ parse: true, ioMethod: 'fetch' }, options)));
    },
    destroy(options = {}) {
        return startIO(this, this.getEndpoint().destroy(this.id, options, this), options, () => {
            const { collection } = this;
            if (collection) {
                collection.remove(this, options);
            }
            else {
                this.dispose();
            }
            return this;
        });
    }
};
//# sourceMappingURL=io-mixin.js.map